import React from 'react'
import { VyneRadio } from '@vynedental/design-system'
import { RadioChangeEvent } from 'antd'

import SelfSchedulingModel from '../../../../models/SelfScheduling'

import './SelfSchedulingButtonStyle.sass'

export type SelfSchedulingButtonStyleProps = {
    style: Models.SelfSchedulingButtonStyle
    updateStyle: (style: Models.SelfSchedulingButtonStyle) => void
}

const moduleName = 'self-scheduling-button-style'

function SelfSchedulingButtonStyle(props: SelfSchedulingButtonStyleProps) {
    const { style = SelfSchedulingModel.defaultButtonStyle } = props

    function updateStyle(e: RadioChangeEvent) {
        props.updateStyle(e.target.value as Models.SelfSchedulingButtonStyle)
    }

    return (
        <div className={moduleName}>
            <h3 className="webcode-section-title">Style:</h3>
            <div className={`${moduleName}__wrapper`}>
                <VyneRadio
                    dataTestId="button-style-default"
                    checked={style === 'default_position'}
                    onChange={updateStyle}
                    name="radio-widget-style"
                    value="default_position"
                    isStandalone
                    style={{ marginBottom: 0 }}
                >
                    Default Position
                </VyneRadio>
            </div>
            <div className={`${moduleName}__wrapper`}>
                <VyneRadio
                    dataTestId="button-style-custom"
                    checked={style === 'custom_position'}
                    onChange={updateStyle}
                    name="radio-widget-style"
                    value="custom_position"
                    isStandalone
                    style={{ marginBottom: 0 }}
                >
                    Custom Position
                </VyneRadio>
            </div>
            <div className={`${moduleName}__wrapper`}>
                <VyneRadio
                    dataTestId="button-style-client"
                    checked={style === 'client_button'}
                    onChange={updateStyle}
                    name="radio-widget-style"
                    value="client_button"
                    isStandalone
                    style={{ marginBottom: 0 }}
                >
                    Client Button
                </VyneRadio>
            </div>
        </div>
    )
}

export default SelfSchedulingButtonStyle
